// 网址正则表达式
export const isWebUrl = (path: string) => {
  const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  return urlRegex.test(path);
};

// Youtube 视频链接
export const CHECK_YOUTUBE_URL_REGEX =
  /(^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/).+$)|(^(https?:\/\/)?(www\.)?dropbox\.com.+$)|(^(https?:\/\/)?drive\.google\.com\/(file\/d\/|uc\?id=).+$)/;

// 检查Email格式
export const CHECK_EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// 检查文案是否包含 <wbr> 标签
export const containsWbrTag = (str) => {
  const regex = /<wbr\s*\/?>/i;
  return regex.test(str);
};
